import React from 'react';
import PropTypes from 'prop-types';

import { Flexer, Textarea } from '@ontruck/orc';

import { withFormikField } from 'utils/formik';
import { injectIntl } from 'react-intl';

const ExtraInfoSection = ({
  className,
  field,
  form,
  stopPreffix,
  locator = false,
  disabledFields = [],
  intl,
}) => {
  const { value = {} } = field;
  const { setFieldValue } = form;
  const t = intl.messages.modules.shipper_order.form.extra_info_section;
  const internalReferenceField = 'internal_reference';
  const commentField = `${stopPreffix}_comment_from_shipper_to_driver`;
  const appointmentInstructionsField = 'appointment_instructions';
  const internalReference = value[internalReferenceField];
  const comment = value[commentField];
  const appointmentInstructions = value.appointment_instructions;

  return (
    <Flexer.Parent className={className} data-testid="extra-info">
      <Flexer.Child mRight="S" flexGrow="1">
        <span className="extra-info__title">{t.intructions_label}</span>
        <Textarea
          placeholder={t.intructions_placeholder}
          labelType="regular"
          value={comment}
          height={'100px'}
          width="L"
          onChange={(e, { value: v }) => setFieldValue(`${field.name}.${commentField}`, v)}
        />
      </Flexer.Child>
      {!locator && (
        <Flexer.Child flexGrow="1">
          <span className="extra-info__title">{t.internal_reference_label}</span>
          <Textarea
            placeholder={t.internal_reference_placeholder}
            labelType="regular"
            value={internalReference}
            height={'100px'}
            width="L"
            onChange={(e, { value: v }) =>
              setFieldValue(`${field.name}.${internalReferenceField}`, v)
            }
            disabled={disabledFields.includes('internal_reference')}
          />
        </Flexer.Child>
      )}
      {value.has_dropoff_appointment && stopPreffix === 'dropoff' && (
        <Flexer.Child data-testid="extra-info__appointment-instructions">
          <span className="extra-info__title">{t.appointment_instructions}</span>
          <Textarea
            placeholder={t.appointment_instructions_placeholder}
            labelType="regular"
            value={appointmentInstructions}
            height={'100px'}
            width="L"
            onChange={(e, { value: v }) =>
              setFieldValue(`${field.name}.${appointmentInstructionsField}`, v)
            }
          />
        </Flexer.Child>
      )}
    </Flexer.Parent>
  );
};

ExtraInfoSection.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object,
  form: PropTypes.object,
  stopPreffix: PropTypes.string,
  disabledFields: PropTypes.array,
};

export default withFormikField(injectIntl(ExtraInfoSection));
